var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "cta-section",
    style: _vm.style
  }, [_c('Container', [_c('div', {
    staticClass: "flex flex-col justify-center items-center sm-md:items-stretch align-center"
  }, [_vm.heading ? _c('h2', [_vm._v(_vm._s(_vm.heading))]) : _vm._e(), _vm._v(" "), _c('cta-btn', _vm._b({
    staticClass: "flex"
  }, 'cta-btn', _vm.content.cta, false)), _vm._v(" "), _vm.caption && !_vm.content.cta.legal ? _c('SanityBlockContent', {
    staticClass: "caption text-center",
    attrs: {
      "blocks": _vm.caption
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _vm.showBgImg ? _c('background-image', {
    attrs: {
      "image": _vm.styles.backgroundImage
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };